/**
 * Created by alvinoktavianus on 5/9/17.
 */

import { call, put, select, takeLatest } from 'redux-saga/effects';
import { change, initialize } from 'redux-form';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import * as is from 'is_js';
import { delay } from 'redux-saga';
import { VerifyBillingResponse } from '@ce-openapi/business-subscription-service-ts-axios-client';

import { unleashHasFeature } from 'mf-shared/utils/featureFlags';
import {
  SETTING_BILLING_BILLINGS,
  SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
  SETTING_BILLING_ON_CLICK_ACTIVE_SUBSCRIPTION,
  SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_ON_CLICK_TURN_BUTTON,
  SETTING_BILLING_PAGE_REQUEST,
  SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
  SETTING_BILLING_PAY_MOKA_SUBSCRIPTION_V2,
  SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES,
  SETTING_BILLING_SEND_CLEVERTAP,
  SETTING_BILLING_UNAPPLY_COUPON_DISCOUNT,
  SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS,
  SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS_V2,
  SETTING_BILLING_VERIFY_BILLING_COUPON,
  SETTING_BILLING_VERIFY_BILLING_COUPON_V2,
} from '../../actions/setting/billing/constant';
import {
  billings,
  featureSubscriptionPrice,
  hideCancelSubscriptionModal,
  hideMarkSubscriptionModal,
  hidePaymentGatewayErrorModal,
  isClickedPayButton,
  isValidatingCoupon,
  onClickTurnButton,
  onSetActiveSubcription,
  onSetActiveSubcriptionV2,
  payButtonMessage,
  rulesOutletsSubscriptionStatus,
  setBillings,
  setBillingsCalculation,
  setCancelSubsciptionModalData,
  setCountFeatureSubscription,
  setCouponDiscount,
  setCouponDiscountRequest,
  setCouponErrorMessage,
  setCurrentSubscriptionPlanName,
  setCurrentSubscriptionRules,
  setDiscountSettings,
  setFeatureSubscriptionPrice,
  setIsCouponValid,
  setIsDeletedOutlet,
  setIsExtendedStaffSlots,
  setminMaxAllOutlet,
  setMinMaxDate,
  setOutlets,
  setPendingPaymentMessage,
  setProgressCursor,
  setPurchasedStaffs,
  setRules,
  setShowProratedText,
  setShowSlotEmployee,
  setSubscriptionStatus,
  setTotalBillingPrice,
  setUnusedOutletMessage,
  showCancelSubscriptionModal,
  showMarkSubscriptionModal,
  showPaymentGatewayErrorModal,
} from '../../actions/setting/billing';
import {
  setNotificationMessage,
  setNotificationType,
} from '../../actions/billingRedirect';
import * as action from '../../actions';
import * as actNotif from '../../actions/notifications';
import { showBillingNotification } from '../../actions/billingNotification';
import { showSubscriptionExpiredModal } from '../../actions/subscriptionExpired';
import { showPageLoadingSpinner } from '../../actions/loadingSpinner';

import {
  cancelSubs,
  cancelSubscription,
  getAllOutlets,
  getBillings,
  getBillingsCalculation,
  getDiscountSettings,
  getFeatureSubscriptionPrice,
  getRules,
  getSubscriptionStatus,
  updateIsActiveSubcription,
  verifyBilling,
  verifyBillingV2,
} from '../../api/billing';
import * as apiProfile from '../../api/profile';
import {
  verifyCouponBilling,
  verifyCouponBillingV2,
} from '../../api/billingCoupon';
import { getActiveEmployees } from '../../api/employees';
import { getSaudagarOutlets } from '../../api/outlets';
import { assertErrorHasData } from '../../utils/assert';
import {
  CLEVERTAP_BILLING_OPEN_PAGE,
  CLEVERTAP_BILLING_PAY,
} from '../../clevertap/constants';
import * as clevertapSettingsBilling from '../../clevertap/settings/billing';
import * as clevertapSettingsBillings from '../../clevertap/settings/billings';

function sendClevertapTracker(actionType, data) {
  try {
    // eslint-disable-next-line default-case
    switch (actionType) {
      case CLEVERTAP_BILLING_OPEN_PAGE: {
        clevertapSettingsBillings.accountSettingsOpenBilling(data);
        break;
      }
      case CLEVERTAP_BILLING_PAY: {
        clevertapSettingsBillings.accountSettingsBillingPay(data);
        break;
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function* getBillingsFlow() {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  yield put(showPageLoadingSpinner(true));
  const response = yield call(getBillings);
  let pendingPaymentMessage: string | null = null;
  forEach(response.data, (invoice) => {
    if (invoice.status === 'pending') {
      if (invoice.payment_type === 'credit_card') {
        pendingPaymentMessage = `There is a pending payment for ${invoice.invoice_number}. Please wait 24 hours before making a new payment.`;
      } else if (
        invoice.payment_type === 'bank_transfer' ||
        invoice.payment_type === 'echannel'
      ) {
        pendingPaymentMessage = `There is a pending payment for ${invoice.invoice_number}. Please transfer full amount of the invoice within 3 days before making a new payment. Please check your email for payment instruction.`;
      }
      return false;
    }
  });
  if (pendingPaymentMessage !== null) {
    yield put(setPendingPaymentMessage(pendingPaymentMessage));
    yield put(isClickedPayButton(true));
  }
  yield put(setBillings(response.data));
  yield put(action.hideProgressBar());
  yield put(action.sendingRequest(false));
}

export function* pageRequest(request) {
  yield put(showPageLoadingSpinner(true));
  // Reset all of the reducer state
  yield put(setBillings([]));
  yield put(setOutlets([]));
  yield put(setRules({}));
  yield put(setSubscriptionStatus([]));
  yield put(setCountFeatureSubscription(0));
  yield put(setCurrentSubscriptionRules({}));
  yield put(isClickedPayButton(false));
  yield put(payButtonMessage('Pay'));
  yield put(hidePaymentGatewayErrorModal());
  yield put(setTotalBillingPrice(0));
  yield put(setPendingPaymentMessage(null));
  yield put(setUnusedOutletMessage(null));
  yield put(setCurrentSubscriptionPlanName(null));
  yield put(hidePaymentGatewayErrorModal());
  yield put(setCancelSubsciptionModalData({}));
  yield put(setFeatureSubscriptionPrice({}));
  yield put(setMinMaxDate({}));
  const { currentPlan, isOwner, billingNotification } = request.payload;
  const responseProfile = yield call(apiProfile.getProfile);
  const isTrial = responseProfile.data.business.is_trial;
  const outletSlot = responseProfile.data.business.outlet_slot;
  const expired = moment(responseProfile.data.business.expired_at) <= moment();
  const businessId = responseProfile.data.business.id;

  const { isEnabled: enableSelfRenewal } = yield select(
    unleashHasFeature('self-renewal-backoffice')
  );

  if (enableSelfRenewal) {
    try {
      const responseCalculation = yield call(
        getBillingsCalculation,
        businessId
      );
      yield put(setBillingsCalculation(responseCalculation));
    } catch (e) {
      console.error(e);
    }
  }

  if (expired) {
    if (!isOwner) {
      yield put(action.logout());
      return;
    }
    yield put(showSubscriptionExpiredModal());
  }
  yield put(billings());
  yield put(
    rulesOutletsSubscriptionStatus(currentPlan, expired, isTrial, outletSlot)
  );
  yield put(showBillingNotification(billingNotification));
  yield put(featureSubscriptionPrice());
  yield put(setNotificationType(null));
  yield put(setNotificationMessage(null));
  yield put(setIsCouponValid(true));
  yield put(setCouponDiscount({}));
  yield put(setCouponDiscountRequest({}));
}

export function* rulesOutletsSubscriptionStatusFlow(request) {
  const { currentPlan, expired, isTrial, outletSlot } = request.payload;
  let outlets;
  let minDate;
  let maxDate;
  let minMaxDate;
  let minMaxDateWithoutActiveSubscription;
  let responseOutlets;
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  // Get all outlets
  if (expired) {
    responseOutlets = yield call(getAllOutlets);
    outlets = responseOutlets.data;

    const dateCollection: any[] = [];
    const outletDateWithoutActiveSubcription: any[] = [];
    forEach(outlets, (outlet) => {
      outletDateWithoutActiveSubcription.push(
        new Date(
          Number(moment(outlet.end_date).format('YYYY')),
          Number(moment(outlet.end_date).format('MM')) - 1,
          Number(moment(outlet.end_date).format('DD'))
        )
      );
      if (
        outlet.is_active_subscription ||
        outlet.is_active_subscription === null
      ) {
        dateCollection.push(
          new Date(
            Number(moment(outlet.end_date).format('YYYY')),
            Number(moment(outlet.end_date).format('MM')) - 1,
            Number(moment(outlet.end_date).format('DD'))
          )
        );
      }
    });
    minMaxDate = {
      minDate: moment(new Date(Math.min.apply(null, dateCollection))).format(
        'DD/MM/YYYY'
      ),
      maxDate: moment(new Date(Math.max.apply(null, dateCollection))).format(
        'DD/MM/YYYY'
      ),
    };

    minMaxDateWithoutActiveSubscription = {
      minDate: moment(
        new Date(Math.min.apply(null, outletDateWithoutActiveSubcription))
      ).format('DD/MM/YYYY'),
      maxDate: moment(
        new Date(Math.max.apply(null, outletDateWithoutActiveSubcription))
      ).format('DD/MM/YYYY'),
    };
  } else {
    responseOutlets = yield call(getSaudagarOutlets);
    outlets = responseOutlets.data.data;

    const dateCollection: any[] = [];
    const outletDateWithoutActiveSubcription: any[] = [];
    forEach(outlets, (outlet) => {
      outletDateWithoutActiveSubcription.push(
        new Date(
          Number(moment(outlet.end_date).format('YYYY')),
          Number(moment(outlet.end_date).format('MM')) - 1,
          Number(moment(outlet.end_date).format('DD'))
        )
      );
      if (
        outlet.is_active_subscription ||
        outlet.is_active_subscription === null
      ) {
        dateCollection.push(
          new Date(
            Number(moment(outlet.end_date).format('YYYY')),
            Number(moment(outlet.end_date).format('MM')) - 1,
            Number(moment(outlet.end_date).format('DD'))
          )
        );
      }
    });

    minMaxDate = {
      minDate: moment(new Date(Math.min.apply(null, dateCollection))).format(
        'DD/MM/YYYY'
      ),
      maxDate: moment(new Date(Math.max.apply(null, dateCollection))).format(
        'DD/MM/YYYY'
      ),
    };

    minMaxDateWithoutActiveSubscription = {
      minDate: moment(
        new Date(Math.min.apply(null, outletDateWithoutActiveSubcription))
      ).format('DD/MM/YYYY'),
      maxDate: moment(
        new Date(Math.max.apply(null, outletDateWithoutActiveSubcription))
      ).format('DD/MM/YYYY'),
    };
    yield put(setminMaxAllOutlet(minMaxDateWithoutActiveSubscription));
    yield put(setMinMaxDate(minMaxDate));
    yield put(setShowProratedText(minDate !== maxDate));
  }

  const isDeleted = {};
  forEach(outlets, (outlet) => {
    if (
      outlet.is_active_subscription ||
      outlet.is_active_subscription === null
    ) {
      outlet.is_active_subscription = true;
      isDeleted[outlet.id] = false;
    } else {
      isDeleted[outlet.id] = !outlet.is_active_subscription;
    }
  });
  yield put(setIsDeletedOutlet(isDeleted));

  // After successfully fetch outlets and update the data,
  // change it to hash map instead array
  const sortedOutlet = orderBy(
    outlets,
    [(outlet) => outlet.name.toLowerCase()],
    ['asc']
  );
  yield put(setOutlets(sortedOutlet));

  const unusedOutlet = isTrial ? 0 : outletSlot - outlets.length;
  if (unusedOutlet > 0) {
    yield put(
      setUnusedOutletMessage(
        `You still have slots for additional ${unusedOutlet} outlets. Please create the outlets before making a payment.`
      )
    );
    yield put(isClickedPayButton(true));
  }

  // Get all rules
  let initialRule = {};
  const responseRules = yield call(getRules);
  const rules = responseRules.data;
  let currentPlanName: any = null;
  yield put(setRules(rules));
  if (rules.subscription_plans.length > 1) {
    forEach(rules.subscription_plans, (plan) => {
      if (plan.name === 'Moka 12 Months') {
        initialRule = plan;
      }
      if (currentPlan === plan.month) {
        currentPlanName = plan.name;
      }
    });
  } else {
    [initialRule] = rules.subscription_plans;
    currentPlanName = (initialRule as any).name;
  }
  // eslint-disable-next-line no-nested-ternary
  currentPlanName = expired
    ? 'Expired'
    : !expired && isTrial
    ? 'Trial'
    : currentPlanName;
  yield put(setCurrentSubscriptionPlanName(currentPlanName));
  yield put(setCurrentSubscriptionRules(initialRule));

  let initialValue = {
    subscriptionRules: 'Moka 12 Months',
    coupon: '',
  };
  // Create redux-form initial value
  if (
    currentPlanName !== 'Expired' &&
    currentPlanName !== 'Trial' &&
    rules.subscription_plans.length <= 1
  ) {
    initialValue = {
      subscriptionRules: currentPlanName,
      coupon: '',
    };
  }

  // Initialize redux-form value
  yield put(initialize('BillingReceipt', initialValue));

  // Get all rules
  const response = yield call(getSubscriptionStatus);
  const featureSubscription = response.data;
  let featureCount = 0;
  forEach(featureSubscription, (feature) => {
    if (feature.is_active && feature.is_subscribing && !feature.on_trial) {
      featureCount++;
      feature.isHaveFeature = true;
      feature.isFeatureNeedToBePaid = true;
      feature.featureActiveUntilDate = null; // please remove is this variable is not using anymore
    } else if (
      feature.is_active &&
      (!feature.is_subscribing || feature.on_trial)
    ) {
      featureCount++;
      const trialExpirationDate = moment(feature.expiration_date);
      feature.isHaveFeature = false;
      feature.featureActiveUntilDate = trialExpirationDate.format('DD/MM/YYYY');
      feature.isFeatureNeedToBePaid = false;
    }
  });
  yield put(setCountFeatureSubscription(featureCount));
  yield put(setSubscriptionStatus(featureSubscription));

  const activeOutletLongestDate = moment(minMaxDate.maxDate, 'DD/MM/YYYY').add(
    (initialRule as any).month,
    'month'
  );
  const outletWithLongestDate = moment(
    minMaxDateWithoutActiveSubscription.maxDate,
    'DD/MM/YYYY'
  );
  if (activeOutletLongestDate.isAfter(outletWithLongestDate)) {
    const resStaffSlots = yield call(getActiveEmployees, {
      params: { isRenewable: true, active: true, status: 'Purchased' },
    });
    yield put(setPurchasedStaffs(resStaffSlots.data));
    yield put(setShowSlotEmployee(true));
    yield put(setIsExtendedStaffSlots(resStaffSlots.data.length > 0));
  } else {
    yield put(setPurchasedStaffs([]));
    yield put(setShowSlotEmployee(false));
    yield put(setIsExtendedStaffSlots(false));
  }
  yield put(action.hideProgressBar());
  yield put(action.sendingRequest(false));
  yield put(showPageLoadingSpinner(false));
}

export function* featureSubscriptionPriceFlow() {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  const response = yield call(getFeatureSubscriptionPrice);
  yield put(setFeatureSubscriptionPrice(response.data));
  yield put(action.hideProgressBar());
  yield put(action.sendingRequest(false));
}

export function* onChangeSubscriptionRulesSaga(newSubscriptionRules) {
  const {
    payload: { subscriptionRules, outletMinMaxDate, minMaxAllOutlet },
  } = newSubscriptionRules;
  yield put(setCurrentSubscriptionRules(subscriptionRules));
  yield put(setIsCouponValid(true));
  yield put(change('BillingReceipt', 'coupon', ''));
  yield put(setCouponDiscount({}));
  yield put(setCouponDiscountRequest({}));
  const activeOutletLongestDate = moment(
    outletMinMaxDate.maxDate,
    'DD/MM/YYYY'
  ).add(subscriptionRules.month, 'month');
  const outletWithLongestDate = moment(minMaxAllOutlet.maxDate, 'DD/MM/YYYY');
  if (activeOutletLongestDate.isAfter(outletWithLongestDate)) {
    const resStaffSlots = yield call(getActiveEmployees, {
      params: { isRenewable: true, active: true, status: 'Purchased' },
    });
    yield put(setPurchasedStaffs(resStaffSlots.data));
    yield put(setShowSlotEmployee(true));
    yield put(setIsExtendedStaffSlots(resStaffSlots.data.length > 0));
  } else {
    yield put(setPurchasedStaffs([]));
    yield put(setShowSlotEmployee(false));
    yield put(setIsExtendedStaffSlots(false));
  }
}

export function* payMokaSubscriptionFlow(request) {
  yield put(action.showProgressBar());
  yield put(isClickedPayButton(true));

  const {
    totalPrice,
    subscriptionPlan,
    purchasedOutlets,
    activatedFeatures,
    couponDiscount,
    couponDiscountRequest,
    isExtendedStaffSlots,
  } = request.payload;
  let response = {};

  const billingData = {
    type: 'SubscriptionBilling',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    total_amount: totalPrice,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    subscription_plan: subscriptionPlan.month,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    feature_ids: activatedFeatures,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    purchased_outlets: purchasedOutlets,
    coupon: isEmpty(couponDiscount)
      ? {}
      : {
          couponDiscount,
          request: couponDiscountRequest,
        },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    extend_slots: isExtendedStaffSlots,
  };

  switch (billingData.subscription_plan) {
    case 1:
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'subscription_name' does not exist on typ... Remove this comment to see the full error message
      billingData.subscription_name = 'Monthly';
      break;
    case 12:
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'subscription_name' does not exist on typ... Remove this comment to see the full error message
      billingData.subscription_name = '12 Months';
      break;
    default:
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'subscription_name' does not exist on typ... Remove this comment to see the full error message
      billingData.subscription_name = 'Total Payment';
  }

  clevertapSettingsBilling.settingBillingPay({ billingData });

  try {
    response = yield call(verifyBilling, billingData);
  } catch (error) {
    assertErrorHasData(error);
    yield put(isClickedPayButton(false));
    if (!error.data || error.data === ' ' || error.status >= 500) {
      yield put(showPaymentGatewayErrorModal());
    } else {
      yield put(actNotif.error(error.data.message));
    }
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
    if ((response as any).data) {
      yield call(sendClevertapTracker, CLEVERTAP_BILLING_PAY, billingData);
      yield put(payButtonMessage('Redirecting to Veritrans'));
      if (is.safari()) {
        yield put(isClickedPayButton(false));
        yield put(payButtonMessage('Pay'));
      }
      window.location.href = (response as any).data.data.redirect_url;
    }
  }
}

export function* payMokaSubscriptionFlowV2(request) {
  yield put(action.showProgressBar());
  yield put(isClickedPayButton(true));

  const {
    subscriptionDiscountId,
    couponCode,
    finalPrice,
    subscriptionName,
    purchasedOutlets,
    businessId,
  } = request.payload;

  const billingData = {
    business_id: businessId,
    subscription_name: subscriptionName,
    total_amount: finalPrice,
    purchased_outlets: purchasedOutlets,
  };

  clevertapSettingsBilling.settingBillingPay({ billingData });

  switch (window.location.hash) {
    case '#fromPopup':
      clevertapSettingsBilling.renewalFullFlow({ billingData });
      break;
    case '#fromBanner':
      clevertapSettingsBilling.renewalBannerClick({ billingData });
      break;
    default:
      clevertapSettingsBilling.renewalBillingPay({ billingData });
  }

  try {
    const response: VerifyBillingResponse = yield call(
      verifyBillingV2,
      subscriptionDiscountId,
      finalPrice,
      couponCode
    );

    if (response.redirect_url) {
      yield call(sendClevertapTracker, CLEVERTAP_BILLING_PAY, billingData);
      yield put(payButtonMessage('Redirecting to Veritrans'));
      if (is.safari()) {
        yield put(isClickedPayButton(false));
        yield put(payButtonMessage('Pay'));
      }
      window.location.href = response.redirect_url;
    }
  } catch (error) {
    yield put(isClickedPayButton(false));
    if (!error.data || error.data === ' ' || error.status >= 500) {
      yield put(showPaymentGatewayErrorModal());
    } else {
      yield put(actNotif.error(error.data.message ?? error.data.status));
    }
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

export function* onClickCancelSubscriptionModalFlow(request) {
  yield put(showCancelSubscriptionModal());
  yield put(
    setCancelSubsciptionModalData(request.payload.featureSubscriptionModalData)
  );
}

export function* cancelFeatureSubscriptionFlow(request) {
  const { featureSubscriptionStatus, business, featureName } = request.payload;
  const {
    outletMinMaxDate: { minDate, maxDate },
  } = request.payload;
  // TODO: https://go-jek.atlassian.net/browse/SKY-153
  const { isEnabled: enableNewApiCancelFeatureSubscription } = yield select(
    unleashHasFeature('backoffice-cancel-feature-subscription-new-api')
  );

  let featureActiveUntilDate;
  let newFeatureStatus;
  let featureId;

  if (enableNewApiCancelFeatureSubscription) {
    const response = yield call(cancelSubs, request.payload.featureName);
    newFeatureStatus = response.data;
    featureId = newFeatureStatus.subscription_price_id;
  } else {
    const response = yield call(
      cancelSubscription,
      request.payload.featureName
    );
    // eslint-disable-next-line prefer-destructuring
    newFeatureStatus = response.data[0];
    featureId = newFeatureStatus.id;
  }
  forEach(featureSubscriptionStatus, (feature, index) => {
    if (feature.id === featureId) {
      featureSubscriptionStatus[index] = newFeatureStatus;
      featureSubscriptionStatus[index].isHaveFeature = false;
      featureSubscriptionStatus[index].featureActiveUntilDate = moment(
        feature.expiration_date
      ).format('DD/MM/YYYY');
      featureSubscriptionStatus[index].isFeatureNeedToBePaid =
        minDate !== maxDate
          ? !(
              minDate >= feature.featureActiveUntilDate &&
              maxDate >= feature.featureActiveUntilDate
            )
          : false;
      featureActiveUntilDate = moment(feature.expiration_date).format(
        'DD/MM/YYYY'
      );
    }
  });
  yield put(setSubscriptionStatus([]));
  yield put(setSubscriptionStatus(featureSubscriptionStatus));
  yield put(setIsCouponValid(true));
  yield put(change('BillingReceipt', 'coupon', ''));
  yield put(setCouponDiscount({}));
  yield put(setCouponDiscountRequest({}));
  clevertapSettingsBilling.mpCancelFeatureSubscription(
    business,
    featureName,
    featureActiveUntilDate
  );
  yield put(hideCancelSubscriptionModal());

  const { isEnabled: enableSelfRenewal } = yield select(
    unleashHasFeature('self-renewal-backoffice')
  );

  // refetch discount settings & billing calculation
  if (enableSelfRenewal) {
    try {
      const responseCalculation = yield call(
        getBillingsCalculation,
        business.id
      );
      yield put(setBillingsCalculation(responseCalculation));

      const responseSettings = yield call(getDiscountSettings, business.id);
      yield put(setDiscountSettings(responseSettings.data));
    } catch (e) {
      console.error(e);
    }
  }
}

export function* onClickTurnButtonFlow(request) {
  const { id, prevIsDeleted } = request.payload;
  const newDeleted = { ...prevIsDeleted };
  newDeleted[id] = !prevIsDeleted[id];
  yield put(setIsDeletedOutlet(newDeleted));
}

export function* onVerifyBillingCoupon(request) {
  const {
    coupon,
    baseSubscription,
    businessId,
    businessTypeId,
    features,
    totalBillingPrice,
  } = request.payload.coupon;
  yield put(isValidatingCoupon(true));
  yield delay(1000, true);
  const requestData = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    business_id: businessId,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    business_type_id: businessTypeId,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    subscription_length: baseSubscription.name,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    month_count: baseSubscription.name === 'ANNUAL' ? 12 : 1,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    base_subscription: baseSubscription,
    features,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    total_billing_price: totalBillingPrice,
  };

  try {
    const response = yield call(verifyCouponBilling, coupon, requestData);
    if (response.data.coupon) {
      yield put(setIsCouponValid(true));
      yield put(
        setCouponDiscount({
          ...response.data.discount_detail,
          code: response.data.coupon.code,
          type: response.data.coupon.benefit_type,
          amount: response.data.coupon.amount,
        })
      );
      yield put(setCouponDiscountRequest(requestData));
      yield put(
        actNotif.success(`Coupon ${response.data.coupon.code} has applied`)
      );
    } else {
      yield put(setIsCouponValid(false));
      yield put(setCouponErrorMessage('Invalid Coupon Code'));
      yield put(change('BillingReceipt', 'coupon', ''));
      yield put(setCouponDiscount({}));
      yield put(setCouponDiscountRequest({}));
    }
  } catch (error) {
    yield put(setIsCouponValid(false));
    yield put(setCouponErrorMessage('Invalid Coupon Code'));
    yield put(change('BillingReceipt', 'coupon', ''));
    yield put(setCouponDiscount({}));
    yield put(setCouponDiscountRequest({}));
  } finally {
    yield put(isValidatingCoupon(false));
    yield delay(4000, true);
    yield put(setIsCouponValid(true));
  }
}

export function* onVerifyBillingCouponV2(request) {
  const {
    coupon,
    businessTypeId,
    businessCategoryId,
    totalOutletPrice,
    subscriptionType,
    features,
    outletCount,
  } = request.payload.params;
  yield put(isValidatingCoupon(true));
  yield delay(1000, true);
  const requestData = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    business_type_id: businessTypeId,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    business_category_id: businessCategoryId,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    total_outlet_price: totalOutletPrice,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    subscription_length: subscriptionType,
    features,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    outlet_count: outletCount,
  };
  try {
    const response = yield call(verifyCouponBillingV2, coupon, requestData);
    yield put(setIsCouponValid(true));
    yield put(
      setCouponDiscount({
        code: response.data.data.coupon.code,
        totalDiscountAmount: response.data.data.benefit.total_discount_amount,
        totalDiscountPercentage:
          response.data.data.benefit.total_discount_percentage,
        additionalMonth: response.data.data.benefit.additional_month,
      })
    );
    yield put(setCouponDiscountRequest(requestData));
    yield put(
      actNotif.success(`Coupon ${response.data.data.coupon.code} has applied`)
    );
  } catch (error) {
    yield put(setIsCouponValid(false));
    const errorMessage = error.message;
    if (
      errorMessage.includes('subscription') ||
      errorMessage === 'Invalid code, price error'
    ) {
      yield put(setCouponErrorMessage(errorMessage));
    } else {
      yield put(setCouponErrorMessage('Invalid Coupon Code'));
    }
    yield put(change('BillingReceipt', 'coupon', ''));
    yield put(setCouponDiscount({}));
    yield put(setCouponDiscountRequest({}));
  } finally {
    yield put(isValidatingCoupon(false));
    yield delay(4000, true);
    yield put(setIsCouponValid(true));
  }
}

export function* onUnapplyCouponDiscount() {
  yield put(change('BillingReceipt', 'coupon', ''));
  yield put(setCouponDiscount({}));
  yield put(setCouponDiscountRequest({}));
}

export function* onClickUpdateIsActiveSubcription(request) {
  const {
    outletId,
    prevIsActive,
    currentRules,
    expired,
    rules,
    staff,
    outlets,
    showModal,
  } = request.payload;

  if (showModal) {
    yield put(
      showMarkSubscriptionModal(
        outletId,
        prevIsActive,
        currentRules,
        expired,
        rules,
        staff,
        outlets,
        showModal
      )
    );
  } else {
    const paramsDeactive = request.payload;

    const { isEnabled: enableSelfRenewal } = yield select(
      unleashHasFeature('self-renewal-backoffice')
    );

    if (enableSelfRenewal) {
      yield put(
        onSetActiveSubcriptionV2({
          outletId,
          isActive: true,
          currentRules,
          expired,
        })
      );
    } else {
      yield put(onSetActiveSubcription(paramsDeactive));
    }
  }
}

export function* onUpdateIsActiveSubcription(request) {
  const { outletId, prevIsActive, currentRules, expired, outlets } =
    request.payload.paramsDeactive;
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  yield put(setProgressCursor(true));
  try {
    const response = yield call(
      updateIsActiveSubcription,
      outletId,
      prevIsActive[outletId]
    );
    const responseOutlet = response.data;
    clevertapSettingsBilling.mpUpdateSubscriptionOutlet(
      responseOutlet.is_active_subscription,
      responseOutlet.business_id,
      responseOutlet.name,
      responseOutlet.end_date
    );
    const copyOutlets: any[] = [];
    yield put(onClickTurnButton(outletId, prevIsActive));
    yield put(setCouponDiscount({}));
    yield put(setCouponDiscountRequest({}));

    const dateCollection: any[] = [];
    const outletDateWithoutActiveSubcription: any[] = [];
    forEach(outlets, (outlet) => {
      if (outlet.id === responseOutlet.id) {
        // eslint-disable-next-line no-param-reassign
        outlet = responseOutlet;
      }
      copyOutlets.push(outlet);

      outletDateWithoutActiveSubcription.push(
        new Date(
          Number(moment(outlet.end_date).format('YYYY')),
          Number(moment(outlet.end_date).format('MM')) - 1,
          Number(moment(outlet.end_date).format('DD'))
        )
      );
      if (
        outlet.is_active_subscription ||
        outlet.is_active_subscription === null
      ) {
        dateCollection.push(
          new Date(
            Number(moment(outlet.end_date).format('YYYY')),
            Number(moment(outlet.end_date).format('MM')) - 1,
            Number(moment(outlet.end_date).format('DD'))
          )
        );
      }
    });

    yield put(setOutlets(copyOutlets));
    const dateToday = moment(new Date()).format('DD/MM/YYYY');
    const minMaxDate = {
      minDate: expired
        ? dateToday
        : moment(new Date(Math.min.apply(null, dateCollection))).format(
            'DD/MM/YYYY'
          ),
      maxDate: expired
        ? dateToday
        : moment(new Date(Math.max.apply(null, dateCollection))).format(
            'DD/MM/YYYY'
          ),
    };

    const minMaxDateWithoutActiveSubscription = {
      minDate: expired
        ? dateToday
        : moment(
            new Date(Math.min.apply(null, outletDateWithoutActiveSubcription))
          ).format('DD/MM/YYYY'),
      maxDate: expired
        ? dateToday
        : moment(
            new Date(Math.max.apply(null, outletDateWithoutActiveSubcription))
          ).format('DD/MM/YYYY'),
    };

    yield put(setMinMaxDate(minMaxDate));
    yield put(setShowProratedText(minMaxDate.minDate !== minMaxDate.maxDate));
    // Get all rules
    let initialRule = {};
    let currentPlanName: string | null = null;
    const responseRules = yield call(getRules);
    const rulesData = responseRules.data;

    yield put(setRules(rulesData));
    if (rulesData.subscription_plans.length > 1) {
      forEach(rulesData.subscription_plans, (plan) => {
        if (plan.name === 'Moka 12 Months') {
          initialRule = plan;
        }
        if (currentRules === plan.month) {
          currentPlanName = plan.name;
        }
      });
    } else {
      [initialRule] = rulesData.subscription_plans;
      currentPlanName = (initialRule as any).name;
    }
    currentPlanName = expired ? 'Expired' : currentPlanName;
    yield put(setCurrentSubscriptionPlanName(currentPlanName));
    yield put(setCurrentSubscriptionRules(initialRule));
    let initialValue = {
      subscriptionRules: 'Moka 12 Months',
      coupon: '',
    };
    // Create redux-form initial value
    if (
      currentPlanName !== 'Expired' &&
      currentPlanName !== 'Trial' &&
      rulesData.subscription_plans.length <= 1
    ) {
      initialValue = {
        subscriptionRules: currentPlanName!,
        coupon: '',
      };
    }
    // Initialize redux-form value
    yield put(initialize('BillingReceipt', initialValue));

    const activeOutletLongestDate = moment(
      minMaxDate.maxDate,
      'DD/MM/YYYY'
    ).add((initialRule as any).month, 'month');
    const outletWithLongestDate = moment(
      minMaxDateWithoutActiveSubscription.maxDate,
      'DD/MM/YYYY'
    );
    if (activeOutletLongestDate.isAfter(outletWithLongestDate)) {
      const resStaffSlots = yield call(getActiveEmployees, {
        params: { isRenewable: true, active: true, status: 'Purchased' },
      });
      yield put(setPurchasedStaffs(resStaffSlots.data));
      yield put(setShowSlotEmployee(true));
      yield put(setIsExtendedStaffSlots(resStaffSlots.data.length > 0));
    } else {
      yield put(setPurchasedStaffs([]));
      yield put(setShowSlotEmployee(false));
      yield put(setIsExtendedStaffSlots(false));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    yield put(hideMarkSubscriptionModal());
    yield put(setProgressCursor(false));
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

// This is the replacement for onUpdateIsActiveSubcription
export function* onUpdateIsActiveSubcriptionV2(request) {
  const { outletId, isActive, currentRules, expired } =
    request.payload.paramsDeactive;

  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  yield put(setProgressCursor(true));

  try {
    const response = yield call(updateIsActiveSubcription, outletId, isActive);
    const responseOutlet = response.data;
    clevertapSettingsBilling.mpUpdateSubscriptionOutlet(
      responseOutlet.is_active_subscription,
      responseOutlet.business_id,
      responseOutlet.name,
      responseOutlet.end_date
    );
    yield put(setCouponDiscount({}));
    yield put(setCouponDiscountRequest({}));

    // refetch discount settings & billing calculation
    const responseCalculation = yield call(
      getBillingsCalculation,
      responseOutlet.business_id
    );
    yield put(setBillingsCalculation(responseCalculation));

    const responseSettings = yield call(
      getDiscountSettings,
      responseOutlet.business_id
    );
    yield put(setDiscountSettings(responseSettings.data));

    // refetch rules
    let initialRule = {};
    let currentPlanName: string | null = null;
    const responseRules = yield call(getRules);
    const rulesData = responseRules.data;
    yield put(setRules(rulesData));

    if (rulesData.subscription_plans.length > 1) {
      forEach(rulesData.subscription_plans, (plan) => {
        if (plan.name === 'Moka 12 Months') {
          initialRule = plan;
        }
        if (currentRules === plan.month) {
          currentPlanName = plan.name;
        }
      });
    } else {
      [initialRule] = rulesData.subscription_plans;
      currentPlanName = (initialRule as any).name;
    }
    currentPlanName = expired ? 'Expired' : currentPlanName;
    yield put(setCurrentSubscriptionPlanName(currentPlanName));
    yield put(setCurrentSubscriptionRules(initialRule));
    let initialValue = {
      subscriptionRules: 'Moka 12 Months',
      coupon: '',
    };
    // Create redux-form initial value
    if (
      currentPlanName !== 'Expired' &&
      currentPlanName !== 'Trial' &&
      rulesData.subscription_plans.length <= 1
    ) {
      initialValue = {
        subscriptionRules: currentPlanName!,
        coupon: '',
      };
    }
    // Initialize redux-form value
    yield put(initialize('BillingReceipt', initialValue));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    yield put(hideMarkSubscriptionModal());
    yield put(setProgressCursor(false));
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

export function* sendclevertapPageRequest(request) {
  const { currentSubscriptionRules, totalOutletPrice, outlets } =
    request.payload;
  if (totalOutletPrice !== 0) {
    const data = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      subscription_plan: currentSubscriptionRules.month,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      total_amount: totalOutletPrice,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      purchased_outlets: outlets,
    };
    yield call(sendClevertapTracker, CLEVERTAP_BILLING_OPEN_PAGE, data);
  }
}

export default function* settingBillingSaga() {
  yield takeLatest(SETTING_BILLING_PAGE_REQUEST, pageRequest);
  yield takeLatest(
    SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES,
    rulesOutletsSubscriptionStatusFlow
  );
  yield takeLatest(SETTING_BILLING_BILLINGS, getBillingsFlow);
  yield takeLatest(
    SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
    onChangeSubscriptionRulesSaga
  );
  yield takeLatest(
    SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
    payMokaSubscriptionFlow
  );
  yield takeLatest(
    SETTING_BILLING_PAY_MOKA_SUBSCRIPTION_V2,
    payMokaSubscriptionFlowV2
  );
  yield takeLatest(
    SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
    onClickCancelSubscriptionModalFlow
  );
  yield takeLatest(
    SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE,
    featureSubscriptionPriceFlow
  );
  yield takeLatest(
    SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
    cancelFeatureSubscriptionFlow
  );
  yield takeLatest(SETTING_BILLING_ON_CLICK_TURN_BUTTON, onClickTurnButtonFlow);
  yield takeLatest(
    SETTING_BILLING_VERIFY_BILLING_COUPON,
    onVerifyBillingCoupon
  );
  yield takeLatest(
    SETTING_BILLING_VERIFY_BILLING_COUPON_V2,
    onVerifyBillingCouponV2
  );
  yield takeLatest(
    SETTING_BILLING_ON_CLICK_ACTIVE_SUBSCRIPTION,
    onClickUpdateIsActiveSubcription
  );
  yield takeLatest(
    SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS,
    onUpdateIsActiveSubcription
  );
  yield takeLatest(
    SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS_V2,
    onUpdateIsActiveSubcriptionV2
  );
  yield takeLatest(
    SETTING_BILLING_UNAPPLY_COUPON_DISCOUNT,
    onUnapplyCouponDiscount
  );
  yield takeLatest(SETTING_BILLING_SEND_CLEVERTAP, sendclevertapPageRequest);
}
